import { exists } from "../../../_helper/util.helper";

/**
 * Configuration for the map input.
 * At the current moment just contains the center (for when there is no coords)
 * and whether or not we can automatically set the marker.
 * In the future, should probably determine which map vendor should be used.
 */
export class AiConfigModel {

  public rewritePublicRemarks: boolean = false;

  constructor(model?: Partial<AiConfigModel>) {
    if (model) {
      if (exists(model.rewritePublicRemarks)) this.rewritePublicRemarks = model.rewritePublicRemarks;
    }
  }
}
